import React from "react";
import Container from "react-bootstrap/Container";

const Footer = (props) => {
  const bgStyle = {
    backgroundColor: "rgb(15, 18, 24)",
    backgroundImage:
      "radial-gradient(circle at 12% 20%, rgba(76, 201, 240, 0.12), transparent 32%), radial-gradient(circle at 85% 28%, rgba(244, 162, 97, 0.12), transparent 34%)",
    borderTop: "1px solid rgba(255, 255, 255, 0.08)",
  };

  return (
    <footer style={bgStyle} className="mt-auto py-5 text-center text-white">
      <Container>
        {props.children}
        <p className="mt-4 mb-1" style={{ color: "rgba(255, 255, 255, 0.9)" }}>
          <strong>TWSystems</strong>
        </p>
        <small style={{ color: "rgba(255, 255, 255, 0.66)" }}>
          Automation systems built for real business outcomes.
        </small>
        {/* <i className="fas fa-code" /> with <i className="fas fa-heart" /> by{" "}
        <a
          rel="noopener"
          href="https://github.com/hashirshoaeb"
          aria-label="My GitHub"
          style={{ color: "#fff" }}
        >
          {" "}
          <span
            className="badge"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.14)",
              color: "#fff",
            }}
          >
            Name Here
          </span>
        </a>{" "}
        using <i className="fab fa-react" />
        <p>
          <small style={{ color: "rgba(255, 255, 255, 0.68)" }}>
            Project code is open source. Feel free to fork and make your own
            version.
          </small>
        </p> */}
      </Container>
    </footer>
  );
};

export default Footer;
